import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      getCurrentUser();
    } else {
      setLoading(false);
    }
  }, []);

  const getCurrentUser = async () => {
    try {
      const response = await api.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      console.error('Get current user error:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      const { token, user: userData, redirectUrl } = response.data;
      
      localStorage.setItem('token', token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(userData);
      
      return { success: true, redirectUrl };
    } catch (error) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Login failed' 
      };
    }
  };
// Admin login function - add this to your AuthContext
const loginAdmin = async (email, password) => {
  try {
    const response = await api.post('/auth/admin-login', { email, password });
    const { token, user: userData, redirectUrl } = response.data;
    
    // Store admin token separately or use different key
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
    
    return { success: true, redirectUrl };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Admin login failed'
    };
  }
};

const signup = async (userData) => {
  try {
    const response = await api.post('/auth/signup', userData);
    
    console.log('✅ Signup API response:', response.data);
    
    // Extract token and store it
    const token = response.data.data.token;
    //alert(token);
    localStorage.setItem('token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    

     setUser(response.data); // ⭐ THIS IS WHAT WAS MISSING
     ////alert(response.data);
    // ⭐ CRITICAL FIX: Return the COMPLETE response.data structure
    return response.data; // Returns: { success: true, message: "...", data: {...} }
    
  } catch (error) {
    console.error('❌ Signup API error:', error);
    throw error;
  }
};
/*  const signup = async (userData) => {
    try {
      const response = await api.post('/auth/signup', userData);
      return { success: true, message: response.data.message };
    } catch (error) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Signup failed' 
      };
    }
  };*/

  const logout = () => {
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const value = {
    user,
    login,
     setUser,   // ⭐ add this
    loginAdmin,
    signup,
    logout,
    loading,
    isAuthenticated: !!user,
    isAdmin: user?.role === 'admin'
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};